import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Trans } from "@lingui/macro";

const mapStateToProps = (state) => {
  return {
    home: state.Home,
  };
};

class NoHouseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      isOpen: false,
      loading: false,
      success: false,
    };
  }

  componentDidMount() {
    this.outer = document.createElement("div");
    this.outer.style.visibility = "hidden";
    this.outer.id = "NoHouseModalButton";
    this.outer.type = "button";
    this.outer.addEventListener("click", (e) => {
      if (e.target.value) this.setState({ text: e.target.value });
      this.toggleModal(true);
    });
    document.body.appendChild(this.outer);

    //TEST
    //this.outer.click();
  }

  componentWillUnmount() {
    this.outer.parentNode.removeChild(this.outer);
  }

  signupHomeClick = () => {
    setTimeout(() => this.props.history.push("/pubblica-annuncio-stanza-appartamento"), 500);
  };

  toggleModal = (bool) => {
    this.setState({ isOpen: bool });
    if (bool) {
      window.history.pushState("popup-open", null, "");
      window.onpopstate = (e) => {
        e.preventDefault();
        this.setState({ isOpen: false });
        window.onpopstate = null;
      }
    } else {
      if(window.history.state === "popup-open")
        window.history.back();
    }
  };

  render() {
    return (
      <Modal
        show={this.state.isOpen}
        onHide={() => this.toggleModal(false)}
        dialogClassName="modal-dialog-centered modal-log-dialog"
      >
        <div className="modal-body text-center">
          <div className="modal-header no-borders">
            <div className=" thipi-text-h2 pb-2"><Trans>Ma contatta... per cosa?</Trans></div>
            <button
              type="button"
              className="close modal-close position-absolute modal-close-top-right"
              onClick={() => this.toggleModal(false)}
            >
              ×
            </button>
          </div>
          <div className="thipi-text-h4">
            <Trans>Per</Trans> {this.state.text}{" "}
            <span className="modal-link"
              onClick={() => {
                if(this.props.home._id === -1){
                  this.signupHomeClick();
                  this.toggleModal(false);
                } else {
                  this.props.history.push("/home-profile");
                  this.toggleModal(false);
                }
              }}
            >
              <Trans>
                crea un nuovo annuncio
              </Trans>
            </span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default compose(withRouter, connect(mapStateToProps))(NoHouseModal);
